export const HEY_IMMO_TREATMENT_GA_PARAMETER = 'PPA-12798-treatment'

type HeyImmoExperimentTrackingParameters = {
  ga_cd_test_ppa: string
}

type HeyImmoExperimentState = {
  trackingParameters?: HeyImmoExperimentTrackingParameters
}

export function getHeyImmoExperimentState(): HeyImmoExperimentState {
  return {
    trackingParameters: {
      ga_cd_test_ppa: HEY_IMMO_TREATMENT_GA_PARAMETER,
    },
  }
}
